import Vue from 'vue';
import $ from 'jquery';
import { mapGetters } from 'vuex';
import Utils from 'src/utils/general';
import ChartUtils from 'src/utils/chart';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    props: {
        concepts: { type: Array, default: () => { []; } }
    },
    data() {
        return {
            sorting: 'frequency'
        };
    },
    computed: {
        ...mapGetters(['currentModel']),
        colours() {
            return this.currentModel.conceptColours;
        },
        sortedConcepts() {
            if (this.sorting === 'color groups') {
                // Sort concepts by color groups in order of their most frequent concept,
                // followed by frequency within each group
                return this.concepts.concat().sort((t1, t2) => {
                    let v = this.currentModel.conceptClusterOrder[t1.name] - this.currentModel.conceptClusterOrder[t2.name];
                    if (v === 0) {
                        v = t2.frequency - t1.frequency;
                    }
                    return v;
                });
            }
            else {
                // Simply sort concepts by frequency
                return this.concepts.concat().sort((t1, t2) => t2.frequency - t1.frequency);
            }
        },
        maxFrequency() {
            return Math.max(...this.concepts.map((t) => t.frequency));
        }
    },
    mounted() {
        this.$nextTick(() => {
            let self = this;
            $(this.$el).find('.dropdown').dropdown({
                onChange: function (value) {
                    self.sorting = value;
                }
            });
        });
    },
    methods: {
        number: FormatUtils.number,
        capitalizeAll: FormatUtils.capitalizeAll,
        // Compute bar width using normalised frequency
        computeBarWidth(concept, maxWidth = 80) {
            return concept.frequency / this.maxFrequency * maxWidth;
        },
        // Emit event for concept hover
        hoverConcept(concept) {
            this.$emit('concept-hovered', concept);
        },
        // Go to Query page for clicked concept
        selectConcept(concept) {
            let queryLink = Utils.generateQueryLink([{
                    type: 'text',
                    values: [concept.name],
                    operator: 'includes'
                }]);
            this.$router.push(queryLink);
        },
        // Is this concept hidden in the storyboard?
        isHidden(concept) {
            return concept.frequencyRank > this.currentModel.numConceptsDisplayed;
        },
        getCsvData() {
            return this.sortedConcepts.map((concept) => {
                let d = {
                    name: concept.name,
                    frequency: concept.frequency,
                    coverage: ChartUtils.formatPercent(concept.nonEmptyCoverage * 100),
                };
                return d;
            });
        }
    }
});
